import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UIService } from '@services';
import { RemoteDiagnosticsStore, RemoteDiagnosticsTab } from '@store';

import { DiagnosticsOverlayTypeEnum } from '../../installation/installation-overlay.model';
@Component({
  selector: 'app-diagnostics-tabs',
  templateUrl: './diagnostics-tabs.component.html',
  styleUrls: ['./diagnostics-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsTabsComponent implements OnInit, OnDestroy {
  diagnosticsOverlayTabs$: Observable<RemoteDiagnosticsTab[]>;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input() activeDiagnosticOverlay: DiagnosticsOverlayTypeEnum;
  @Input() installationId: number;
  @Input() gatewaySerial: string;
  @Input() deviceSerial: string;

  constructor(
    private uiService: UIService,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore
  ) {}

  ngOnInit(): void {
    this.diagnosticsOverlayTabs$ = this.remoteDiagnosticsStore.selectRemoteDiagnosticsTabs(
      this.gatewaySerial
    );
  }

  onTabSelect(type: DiagnosticsOverlayTypeEnum): void {
    if (type !== this.activeDiagnosticOverlay) {
      this.remoteDiagnosticsStore.tabChanged();
      this.uiService.openDiagnosticOverlay(
        type,
        this.installationId,
        this.gatewaySerial,
        this.deviceSerial
      );

      this.uiService.activeDiagnosticOverlay$.next(type);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
